import React from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  FormGroup,
  Form,
  Input,
  Container,
  Row,
  Alert,
  Col,
  Progress
} from "reactstrap";
// core components
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import UserHeader from "../../../components/Headers/UserHeader.jsx";
import Helper from '../../../helpers/helper';
import moment from '../../../../node_modules/moment';
import { Redirect } from 'react-router-dom';
import UserApi from '../../../API/userapi';
import InlineError from '../../../components/messages/InlineError';
import Pagination from "react-js-pagination";
import noImage from '../../../assets/img/theme/dummy256x256.png'

class Profile extends React.Component {
  constructor() {
    super();
    this.state = {
      visible: false,
      data: {
        // user_id: '',
        // username: '',
        email: '',
        title: '',
        name: '',
        mobile_no: '',
        qualification: '',
        address: '',
        pincode: '',
        images: []
      },
      imageLink: {},
      userDetails: {
        user_id: '',
        username: '',
        email: '',
        title: '',
        name: '',
        mobile_no: '',
        qualification: '',
        address: '',
        pincode: '',
        is_active: '',
        is_admin: '',
        user_type: '',
        last_seen: '',
        activity_points: '',
        createdAt: '',
        updatedAt: '',
        my_invitation_code: '',
        iam_invited_code: '',
        profile_completeness:0,
        totalPoints:0,
        images: []
      },
      paramData:{
        per_page:5,
        pageno:1
      },
      activePage: 1,
      activityLog:[],
      totalLogCount:1,
      redirect: false,
      errors: {}
    };
    this.updateProfile = this.updateProfile.bind(this);
    this.onChange = this.onChange.bind(this);
    this.fileChangedHandler = this.fileChangedHandler.bind(this);
    this.onDismiss = this.onDismiss.bind(this);
    this.handlePageChange = this.handlePageChange.bind(this);
  }
  handlePageChange=(pageNumber) =>{
    this.setState({ activePage: pageNumber });
    this.setState(prevState => ({
      paramData: {...prevState.paramData,pageno:pageNumber}
    }))
    this.loadData();
  }
  componentWillMount() { 
    this.loadData();
  }
  loadData=()=> {
    Helper.authenticateToken().then(() => {
      UserApi.userDetailsToken("/users/profile").then((pdresult) => {
        localStorage.setItem('userDetails', JSON.stringify(pdresult.profile_details));
        let result = pdresult.profile_details;
        this.setState({ userDetails: result });
        let newdata = {
          // user_id: result.id !== null ? result.id : '',
          // username: result.username !== null ? result.username : '',
          title: result.title !== null ? result.title : '',
          name: result.name !== null ? result.name : '',
          mobile_no: result.mobile_no !== null ? result.mobile_no : '',
          address: result.address !== null ? result.address : '',
          pincode: result.pincode !== null ? result.pincode : '',
          email: result.email !== null ? result.email : '',
          qualification: result.qualification !== null ? result.qualification : '',
          images: (result.images !== undefined || result.images.length >= 1) ? result.images : [],
          totalPoints:result.totalPoints,
          profile_completeness:result.profile_completeness
        }
        // this.setState({ imageLink: result.images !== null ? result.images : '' });
        this.setState({ data: newdata });
        UserApi.myActivityLog("/activity/log",this.state.paramData).then((activitylog) => {
          this.setState({activityLog:activitylog.data,totalLogCount:activitylog.total_data});
        })
      })
    })
  }

  updateProfile = () => {
    Helper.authenticateToken(this.state).then(() => {
      const errors = this.validate(this.state.data);
      this.setState({ errors });
      if (Object.keys(errors).length === 0) {

        UserApi.updateProfile('/users/update-profile', this.state.data).then((result) => {
          if (result.data.status === "success") {
            UserApi.userDetailsToken("/users/profile").then((pdresult) => {
              localStorage.setItem('userDetails', JSON.stringify(pdresult.profile_details));
            });
            this.setState({ visible: true });
            setTimeout(function () {
              this.setState({redirect: true});
            }.bind(this), 3000)
          } else {
            this.setState({ errors: result.data.error_description, loading: false });
          }
        })

      }
    })
  }

  validate = (data) => {
    const errors = {};
    if (!data.name) errors.name = "Name is Required";
    // if (!data.username) errors.username = "Username is Required";
    return errors;
  }
  onChange = e => {
    this.setState({
      data: { ...this.state.data, [e.target.name]: e.target.value }
    })
  }

  fileChangedHandler = event => {
    let img = event.target.files;
    //this.setState(this.state.data.images=img);
    this.setState(prevState => ({
      data: { ...prevState.data, images: img }
    }))
  }

  onDismiss() {
    this.setState({ visible: false });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={'/admin/index'} />
    }
    const { data, userDetails, errors, visible,activityLog } = this.state;
    return (
      <>
        <UserHeader name={((userDetails.name !== null && userDetails.name !== '') ? ((userDetails.title !== null && userDetails.title !== '') ? userDetails.title : '') + ' ' + userDetails.name : userDetails.username)} />
        {/* Page content */}
        <Container className="mt--7" fluid>
          <Row>
            <Col className="order-xl-2 mb-5 mb-xl-0" xl="4">
              <Card className="card-profile shadow">
                <Row className="justify-content-center">
                  <Col className="order-lg-2" lg="3">
                    <div className="card-profile-image">
                      <a href="#pablo" onClick={e => e.preventDefault()}>
                        <img
                          alt={userDetails.images.length}
                          className="rounded-circle"
                          src={(userDetails.images.length >= 1) ? userDetails.images : noImage}
                        />
                      </a>
                    </div>
                  </Col>
                </Row>
                <CardHeader className="text-center border-0 pt-8 pt-md-4 pb-0 pb-md-4">
                  <div className="d-flex justify-content-between">
                    <Button
                      className="mr-4"
                      color={userDetails.is_active === 1 ? 'info' : 'danger'}
                      size="sm"
                    >
                      {userDetails.is_active === 0 ? 'Inactive User' : userDetails.is_active === 1 ? 'Active User' : userDetails.is_active === 2 ? 'Deleted' : 'Banned'}
                    </Button>
                    <Button
                      className="float-right"
                      color="default"
                      size="sm"
                    >
                      {(userDetails.is_admin === 0 && userDetails.user_type === 1) ? 'Volunteer' : (userDetails.is_admin === 0 && userDetails.user_type === 2) ? 'Regs. User' : (userDetails.is_admin === 1 && userDetails.user_type === 2) ? 'BOC User' : 'Admin User'}
                    </Button>
                  </div>
                </CardHeader>
                <CardBody className="pt-0 pt-md-4">
                  <Row>
                    <div className="col">
                      <div className="card-profile-stats d-flex justify-content-center mt-md-5">
                        <div>
                          <span className="heading">{userDetails.totalPoints !== null && userDetails.totalPoints !== '' ? userDetails.totalPoints : '0'}</span>
                          <span className="description">Activity Points</span>
                        </div>
                      </div>
                    </div>
                  </Row>
                  <div className="text-center">
                  <div className="text-center">{userDetails.profile_completeness.toFixed(2)}%</div>
                     <Progress value={userDetails.profile_completeness.toFixed(2)} />
                  </div>
                  <div className="text-center">
                    <h3>
                      {((userDetails.name !== null && userDetails.name !== '') ? ((userDetails.title !== null && userDetails.title !== '') ? userDetails.title : '') + ' ' + userDetails.name : userDetails.username)}
                    </h3>
                    <div className="h5 font-weight-300">
                      <i className="ni location_pin mr-2" />
                      Last Seen - {userDetails.last_seen !== null && userDetails.last_seen !== '' ? moment(userDetails.last_seen).calendar() : 'Not Updated'}
                    </div>
                    <div className="h5 mt-4" style={{ textAlign: "left" }}>
                      Email ID - {userDetails.email !== null && userDetails.name !== '' ? userDetails.email : 'Not Provided'}
                      <br />
                      Mobile No. - {userDetails.mobile_no !== null && userDetails.mobile_no !== '' ? userDetails.mobile_no : 'Not Provided'}
                      <br />
                      Profile Created - {userDetails.createdAt !== null && userDetails.createdAt !== '' ? moment(userDetails.createdAt).format('LLLL') : 'Not Updated'}
                      <br />
                      Last Updated - {userDetails.updatedAt !== null && userDetails.updatedAt !== '' ? moment(userDetails.updatedAt).format('LLLL') : 'Not Updated'}
                    </div>
                    <hr className="my-4" />
                    <div className="h5 mt-4" style={{ textAlign: "left" }}>
                      Address - {userDetails.address !== null && userDetails.address !== '' ? userDetails.address : 'Not Provided'} , {userDetails.pincode !== null && userDetails.pincode !== '' ? userDetails.pincode : ''}
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
            <Col className="order-xl-1" xl="8">
              <Card className="bg-secondary shadow">
                <CardHeader className="bg-white border-0">
                  <Row className="align-items-center">
                    <Col xs="8">
                      <h3 className="mb-0">My Account</h3>
                    </Col>
                    {/* <Col className="text-right" xs="4">
                      <Button
                        color="primary"
                        href="#pablo"
                        onClick={e => e.preventDefault()}
                        size="sm"
                      >
                        Settings
                      </Button>
                    </Col> */}
                  </Row>
                </CardHeader>
                <CardBody>
                <Tabs>
              <TabList>
                <Tab><i className="fas fa-user-circle"></i> Account Details</Tab>
                <Tab><i className="fas fa-walking"></i> Activity Log</Tab>
              </TabList>
          
              <TabPanel>
              {visible ? <Alert color="success" isOpen={visible} toggle={this.onDismiss}>
                              User profile details updated successfully!
                  </Alert> : ''}
                  
                  <Form encType="multipart/form-data">
                    <h6 className="heading-small text-muted mb-4">
                      User information
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Title
                            </label>
                            <select id="input-first-name" className="form-control" name="title" value={data.title} onChange={this.onChange}>
                              <option>Select Title</option>
                              <option value="Mr">Mr</option>
                              <option value="Mrs">Mrs</option>
                              <option value="Ms">Ms</option>
                              <option value="Shri">Shri</option>
                              <option value="Smt">Smt</option>
                            </select>
                          </FormGroup>
                        </Col>
                        <Col lg="8">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-first-name"
                            >
                              Full name
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-first-name"
                              placeholder="Enter your name"
                              type="text"
                              name="name"
                              value={data.name}
                              // disabled
                              onChange={this.onChange}
                            />
                            {errors.name && <InlineError text={errors.name} />}
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-username"
                            >
                              Username
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-username"
                              placeholder="Username"
                              type="text"
                              name="username"
                              value={userDetails.username}
                              disabled
                            // onChange={this.onChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="6">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-email"
                            >
                              Email address
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-email"
                              placeholder="xyz@example.com"
                              type="email"
                              name="email"
                              value={data.email}
                              // disabled
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <hr className="my-4" />
                    {/* Address */}
                    <h6 className="heading-small text-muted mb-4">
                      Contact information
                    </h6>
                    <div className="pl-lg-4">
                      <Row>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-mobile"
                            >
                              Mobile Number
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-mobile"
                              placeholder="Mobile no."
                              type="text"
                              maxLength="10"
                              name="mobile_no"
                              value={data.mobile_no}
                              // disabled
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="8">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-image"
                            >
                              Profile Image
                            </label>
                            <Input
                              className="form-control"
                              id="images"
                              placeholder="images"
                              type="file"
                              name="images"
                              accept="image/*"
                              onChange={this.fileChangedHandler}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="12">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-qualification"
                            >
                              Qualification
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-qualification"
                              placeholder="Qualification"
                              type="text"
                              name="qualification"
                              value={data.qualification !== null && data.qualification !== '' ? data.qualification : ''}
                              // disabled
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row>
                        <Col lg="8">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-address"
                            >
                              Address
                            </label>
                            <Input
                              className="form-control-alternative"
                              // defaultValue="Bld Mihail Kogalniceanu, nr. 8 Bl 1, Sc 1, Ap 09"
                              id="input-address"
                              placeholder="Home Address"
                              rows="2"
                              type="textarea"
                              name="address"
                              value={data.address}
                              // disabled
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </Col>
                        <Col lg="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="input-postal-code"
                            >
                              Postal code
                            </label>
                            <Input
                              className="form-control-alternative"
                              id="input-postal-code"
                              placeholder="Postal code"
                              type="text"
                              maxLength="6"
                              name="pincode"
                              value={data.pincode}
                              // disabled
                              onChange={this.onChange}
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                    </div>
                    <hr className="my-4" />
                    {/* Description */}

                    <div className="pl-lg-4 text-right">
                      <Button
                        color="info"
                        onClick={this.updateProfile}
                      >
                        Update profile
                      </Button>
                    </div>
                  </Form>
                </TabPanel>
                <TabPanel>
                <div className="row">
                              {(activityLog !== 0) ?
                                activityLog.map((item, index) => {
                                return(<div className="col-md-12 col-12" key={item}>
                                      <div className="log">
                                        <div className="row">
                                            <div className="col-md-12 col-12">{item.activity_description}</div>
                                            <div className="col-md-4 col-12">
                                              <b>Type:</b> {item.activity_type}
                                            </div>
                                              <div className="col-md-6 col-12"> 
                                                <b>Date:</b> {moment(item.activity_date).format('DD/MM/YYYY HH:mm:ss')}
                                              </div>
                                        </div>
                                      </div>
                                    </div>)
                                    }): <Alert color="warning"  className="col-md-12 col-12 ">
                                    <strong>Sorry!</strong>  No Data Found!
                              </Alert>
                                }</div>
                                {activityLog!==0?
                          <div className="pag text-right mr-2">
                            <Pagination className="pagination pagination-lg"
                                        listClassName="pagination-lg"
                                      activePage={this.state.activePage}
                                      itemsCountPerPage={5}
                                      totalItemsCount={this.state.totalLogCount}
                                      pageRangeDisplayed={5}
                                      onChange={this.handlePageChange}
                                    /> 
                          </div>:''
                      }
                </TabPanel>
              </Tabs>
                 
                </CardBody>
              </Card>
            </Col>
          
          </Row>
        </Container>
      </>
    );
  }

}

export default Profile;
